import { FaAngleRight, FaAngleLeft, FaTrash, FaAngleUp, FaAngleDown } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar, Nav, Dropdown, Form, Button, Modal, Table } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import CarePlan from './CarePlan';
import Activities from '../Pages/Activities';
import '../Pages/Activities.css'
function CarePlanDetail() {

    const { id, dateCreated, cpID } = useParams();

    const [carePlan, setCarePlan] = useState(null);
    const [activities, setActivities] = useState([]);
    const [Defaultactivities] = useState([1, 2, 3, 4, 5, 6.7]);
    const [lineItems, setLineItems] = useState([]);
    const [temp, setTemp] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [edit, setEdit] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const [selectedActivity, setSelectedActivity] = useState({
        ActivityID: '',
        Multiplier: 1,
        ActivityName: '',
        Frequency: '',
        SN_HoursDay: 0,
        SN_HoursNight: 0,
        ENA_HoursDay: 0,
        ENA_HoursNight: 0,
        CW_HoursDay: 0,
        CW_HoursNight: 0,
        BenefitBody: '',
        BenefitMind: '',
        BenefitSocial: '',
        DateFrom: '',
        DateTo: '',
    });
    const [noActivities, setNoActivities] = useState(false);
    const [creatingCarePlan, setCreatingCarePlan] = useState(false);

    const [totals, setTotals] = useState({
        SN_HoursDay: 0,
        SN_HoursNight: 0,
        ENA_HoursDay: 0,
        ENA_HoursNight: 0,
        CW_HoursDay: 0,
        CW_HoursNight: 0,
    });

    const [benefitsTotals, setbenefitsTotals] = useState({
        BenefitBody: 0,
        BenefitMind: 0,
        BenefitSocial: 0
    });

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = lineItems.filter(item =>
            item.ActivityName.toLowerCase().includes(value)
        );
        setFilteredItems(filtered);
    };

    const handleSort = (key, isNumeric = false) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        const sortedData = [...filteredItems].sort((a, b) => {
            if (isNumeric) {
                return direction === 'ascending'
                    ? (a[key] || 0) - (b[key] || 0)
                    : (b[key] || 0) - (a[key] || 0);
            } else {
                return direction === 'ascending'
                    ? (a[key] || '').toString().localeCompare((b[key] || '').toString())
                    : (b[key] || '').toString().localeCompare((a[key] || '').toString());
            }
        });

        setFilteredItems(sortedData);
        setSortConfig({ key, direction });
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? <FaAngleUp /> : <FaAngleDown />;
        }
        return null;
    };


    useEffect(() => {
        const fetchCarePlan = async () => {
            try {
                const response = await fetch(`https://marzdev.yourcrm.co.za/api/careplans/${id}/${dateCreated}`);
                if (response.ok) {
                    const data = await response.json();
                    setCarePlan(data.carePlan);
                    setLineItems(data.lineItems);
                    setTemp(data.lineItems);
                    setFilteredItems(data.lineItems);
                    // Calculate totals considering the multiplier
                    const calculatedTotals = data.lineItems.reduce((totals, item) => {
                        const multiplier = parseFloat(item.Multiplier) || 1;
                        return {
                            SN_HoursDay: totals.SN_HoursDay + (parseFloat(item.SN_HoursDay || 0) * multiplier),
                            SN_HoursNight: totals.SN_HoursNight + (parseFloat(item.SN_HoursNight || 0) * multiplier),
                            ENA_HoursDay: totals.ENA_HoursDay + (parseFloat(item.ENA_HoursDay || 0) * multiplier),
                            ENA_HoursNight: totals.ENA_HoursNight + (parseFloat(item.ENA_HoursNight || 0) * multiplier),
                            CW_HoursDay: totals.CW_HoursDay + (parseFloat(item.CW_HoursDay || 0) * multiplier),
                            CW_HoursNight: totals.CW_HoursNight + (parseFloat(item.CW_HoursNight || 0) * multiplier),
                        };
                    }, {
                        SN_HoursDay: 0,
                        SN_HoursNight: 0,
                        ENA_HoursDay: 0,
                        ENA_HoursNight: 0,
                        CW_HoursDay: 0,
                        CW_HoursNight: 0,
                    });

                    setTotals(calculatedTotals);  // Update totals state

                    // Calculate benefit totals (if needed)
                    const calculatedBenefitTotals = data.lineItems.reduce((benefitsTotals, item) => {

                        return {

                            BenefitBody:
                                (parseFloat(benefitsTotals.BenefitBody || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitBody) / 100) || 0)).toFixed(2),

                            BenefitMind:
                                (parseFloat(benefitsTotals.BenefitMind || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitMind) / 100) || 0)).toFixed(2),

                            BenefitSocial:
                                (parseFloat(benefitsTotals.BenefitSocial || 0) +
                                    (
                                        Number(item.SN_HoursDay) +
                                        Number(item.SN_HoursNight) +
                                        Number(item.ENA_HoursDay) +
                                        Number(item.ENA_HoursNight) +
                                        Number(item.CW_HoursDay) +
                                        Number(item.CW_HoursNight)
                                    ) * ((Number(item.BenefitSocial) / 100) || 0)).toFixed(2),

                        };
                    }, {
                        BenefitBody: 0,
                        BenefitMind: 0,
                        BenefitSocial: 0,
                    });

                    // Set benefit totals if needed
                    setbenefitsTotals(calculatedBenefitTotals);

                } else if (response.status === 404) {

                    setCreatingCarePlan(true);

                } else {
                    console.error('Failed to fetch care plan');
                }
            } catch (error) {
                console.error('An error occurred while fetching the care plan:', error);
            }
        };




        const fetchActivities = async () => {
            try {
                const response = await fetch(`https://marzdev.yourcrm.co.za/api/careitemactivities`);
                const data = await response.json();
                if (Array.isArray(data)) {
                    const sortedActivities = data.sort((a, b) =>
                        a.ActivityName.localeCompare(b.ActivityName)
                    );
                    setActivities(sortedActivities);
                } else {
                    console.error('Unexpected data format for activities:', data);
                    setActivities([]); // Default to an empty array if the data is not as expected
                }
                if (data.length === 0) {
                    setNoActivities(true);
                }
            } catch (error) {
                console.error('Failed to fetch activities:', error);
                setActivities([]); // Set an empty array in case of error
            }
        };

        fetchCarePlan();
        fetchActivities();

    }, [id, dateCreated]);

    const handleActivityChange = (e) => {
        const activity = JSON.parse(e.target.value);
        setSelectedActivity(activity);
    };

    const handleMultiplierChange = (index, value) => {
        // Allow empty input and ensure default value is 1 for invalid input
        const newMultiplier = value === '' ? '' : parseFloat(value) || 1;

        const updatedLineItems = [...lineItems];
        const oldItem = updatedLineItems[index];

        // Capture the previous multiplier to adjust the values accordingly
        const oldMultiplier = parseFloat(oldItem.Multiplier) || 1;

        // updatedLineItems[index] = {
        //     ...oldItem,
        //     Multiplier: newMultiplier,
        //     SN_HoursDay: newMultiplier === '' ? oldItem.SN_HoursDay : ((parseFloat(oldItem.SN_HoursDay) / oldMultiplier) * newMultiplier).toFixed(2),
        //     SN_HoursNight: newMultiplier === '' ? oldItem.SN_HoursNight : ((parseFloat(oldItem.SN_HoursNight) / oldMultiplier) * newMultiplier).toFixed(2),
        //     ENA_HoursDay: newMultiplier === '' ? oldItem.ENA_HoursDay : ((parseFloat(oldItem.ENA_HoursDay) / oldMultiplier) * newMultiplier).toFixed(2),
        //     ENA_HoursNight: newMultiplier === '' ? oldItem.ENA_HoursNight : ((parseFloat(oldItem.ENA_HoursNight) / oldMultiplier) * newMultiplier).toFixed(2),
        //     CW_HoursDay: newMultiplier === '' ? oldItem.CW_HoursDay : ((parseFloat(oldItem.CW_HoursDay) / oldMultiplier) * newMultiplier).toFixed(2),
        //     CW_HoursNight: newMultiplier === '' ? oldItem.CW_HoursNight : ((parseFloat(oldItem.CW_HoursNight) / oldMultiplier) * newMultiplier).toFixed(2),
        // };
        updatedLineItems[index] = {
            ...oldItem,
            Multiplier: newMultiplier,
            SN_HoursDay: newMultiplier === '' ? oldItem.SN_HoursDay : ((parseFloat(oldItem.SN_HoursDay))).toFixed(2),
            SN_HoursNight: newMultiplier === '' ? oldItem.SN_HoursNight : ((parseFloat(oldItem.SN_HoursNight))).toFixed(2),
            ENA_HoursDay: newMultiplier === '' ? oldItem.ENA_HoursDay : ((parseFloat(oldItem.ENA_HoursDay))).toFixed(2),
            ENA_HoursNight: newMultiplier === '' ? oldItem.ENA_HoursNight : ((parseFloat(oldItem.ENA_HoursNight))).toFixed(2),
            CW_HoursDay: newMultiplier === '' ? oldItem.CW_HoursDay : ((parseFloat(oldItem.CW_HoursDay))).toFixed(2),
            CW_HoursNight: newMultiplier === '' ? oldItem.CW_HoursNight : ((parseFloat(oldItem.CW_HoursNight))).toFixed(2),
        };

        // Update the line items
        // setLineItems(newLineItems);
        lineItems[index].Multiplier = newMultiplier;
        recalculateTotals(updatedLineItems);
    };


    // Add this function to handle when the input loses focus
    const handleMultiplierBlur = (index, value) => {
        const updatedLineItems = [...lineItems];

        // Set the multiplier back to 1 if the input is empty
        if (value === '') {
            updatedLineItems[index].Multiplier = 1;
        }

        setLineItems(updatedLineItems);
        setFilteredItems(updatedLineItems);
        recalculateTotals(updatedLineItems);
    };

    // Helper function to recalculate totals
    const recalculateTotals = (lineItems) => {
        const newTotals = lineItems.reduce((totals, item) => {
            const multiplier = parseFloat(item.Multiplier) || 1;
            return {
                SN_HoursDay: totals.SN_HoursDay + (parseFloat(item.SN_HoursDay) * multiplier),
                SN_HoursNight: totals.SN_HoursNight + (parseFloat(item.SN_HoursNight) * multiplier),
                ENA_HoursDay: totals.ENA_HoursDay + (parseFloat(item.ENA_HoursDay) * multiplier),
                ENA_HoursNight: totals.ENA_HoursNight + (parseFloat(item.ENA_HoursNight) * multiplier),
                CW_HoursDay: totals.CW_HoursDay + (parseFloat(item.CW_HoursDay) * multiplier),
                CW_HoursNight: totals.CW_HoursNight + (parseFloat(item.CW_HoursNight) * multiplier),
            };
        }, {
            SN_HoursDay: 0,
            SN_HoursNight: 0,
            ENA_HoursDay: 0,
            ENA_HoursNight: 0,
            CW_HoursDay: 0,
            CW_HoursNight: 0,
        });

        setTotals(newTotals);
    };

    const handleRemoveLineItem = (index) => {
        const removedItem = lineItems[index];
        const updatedLineItems = lineItems.filter((_, i) => i !== index);

        // Calculate hours to subtract based on the multiplier
        const hoursToSubtract = {
            SN_HoursDay: parseFloat(removedItem.SN_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1),
            SN_HoursNight: parseFloat(removedItem.SN_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1),
            ENA_HoursDay: parseFloat(removedItem.ENA_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1),
            ENA_HoursNight: parseFloat(removedItem.ENA_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1),
            CW_HoursDay: parseFloat(removedItem.CW_HoursDay || 0) * (parseFloat(removedItem.Multiplier) || 1),
            CW_HoursNight: parseFloat(removedItem.CW_HoursNight || 0) * (parseFloat(removedItem.Multiplier) || 1),
        };

        const benefithoursToSubtract = {
            BenefitBody: parseFloat(removedItem.BenefitBody || 0),
            BenefitMind: parseFloat(removedItem.BenefitMind || 0),
            BenefitSocial: parseFloat(removedItem.BenefitSocial || 0),
        };

        // Update lineItems state
        setLineItems(updatedLineItems);
        setFilteredItems(updatedLineItems);
        // Calculate new totals after removal
        const newTotals = {
            SN_HoursDay: totals.SN_HoursDay - hoursToSubtract.SN_HoursDay,
            SN_HoursNight: totals.SN_HoursNight - hoursToSubtract.SN_HoursNight,
            ENA_HoursDay: totals.ENA_HoursDay - hoursToSubtract.ENA_HoursDay,
            ENA_HoursNight: totals.ENA_HoursNight - hoursToSubtract.ENA_HoursNight,
            CW_HoursDay: totals.CW_HoursDay - hoursToSubtract.CW_HoursDay,
            CW_HoursNight: totals.CW_HoursNight - hoursToSubtract.CW_HoursNight,
        };

        setTotals(newTotals);

        // Calculate the total hours removed
        const totalHoursRemoved = Object.values(hoursToSubtract).reduce((acc, curr) => acc + curr, 0);

        // Update benefits totals with proper parsing
        const newbenefitTotals = {
            BenefitBody: parseFloat(benefitsTotals.BenefitBody || 0) -
                (totalHoursRemoved * (benefithoursToSubtract.BenefitBody / 100)),

            BenefitMind: parseFloat(benefitsTotals.BenefitMind || 0) -
                (totalHoursRemoved * (benefithoursToSubtract.BenefitMind / 100)),

            BenefitSocial: parseFloat(benefitsTotals.BenefitSocial || 0) -
                (totalHoursRemoved * (benefithoursToSubtract.BenefitSocial / 100)),
        };

        setbenefitsTotals({
            BenefitBody: newbenefitTotals.BenefitBody.toFixed(2),
            BenefitMind: newbenefitTotals.BenefitMind.toFixed(2),
            BenefitSocial: newbenefitTotals.BenefitSocial.toFixed(2),
        });
    };

    const handleAddLineItem = () => {
        if (!selectedActivity.ActivityID) {
            alert('Please select an activity.');
            return;
        }

        const selectedMultiplier = parseFloat(selectedActivity.Multiplier) || 1;
        const newItem = {
            ...selectedActivity,
            SN_HoursDay: (parseFloat(selectedActivity.SN_HoursDay) * selectedMultiplier).toFixed(2),
            SN_HoursNight: (parseFloat(selectedActivity.SN_HoursNight) * selectedMultiplier).toFixed(2),
            ENA_HoursDay: (parseFloat(selectedActivity.ENA_HoursDay) * selectedMultiplier).toFixed(2),
            ENA_HoursNight: (parseFloat(selectedActivity.ENA_HoursNight) * selectedMultiplier).toFixed(2),
            CW_HoursDay: (parseFloat(selectedActivity.CW_HoursDay) * selectedMultiplier).toFixed(2),
            CW_HoursNight: (parseFloat(selectedActivity.CW_HoursNight) * selectedMultiplier).toFixed(2),
        };

        setLineItems([...lineItems, newItem]);
        setFilteredItems([...filteredItems, newItem]);

        const newTotals = {
            SN_HoursDay: totals.SN_HoursDay + parseFloat(newItem.SN_HoursDay),
            SN_HoursNight: totals.SN_HoursNight + parseFloat(newItem.SN_HoursNight),
            ENA_HoursDay: totals.ENA_HoursDay + parseFloat(newItem.ENA_HoursDay),
            ENA_HoursNight: totals.ENA_HoursNight + parseFloat(newItem.ENA_HoursNight),
            CW_HoursDay: totals.CW_HoursDay + parseFloat(newItem.CW_HoursDay),
            CW_HoursNight: totals.CW_HoursNight + parseFloat(newItem.CW_HoursNight),
        };

        setTotals(newTotals);

        const newbenefitTotals = {
            BenefitBody:
                (parseFloat(benefitsTotals.BenefitBody || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(selectedActivity.BenefitBody) / 100)).toFixed(2),

            BenefitMind:
                (parseFloat(benefitsTotals.BenefitMind || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(selectedActivity.BenefitMind) / 100)).toFixed(2),

            BenefitSocial:
                (parseFloat(benefitsTotals.BenefitSocial || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(selectedActivity.BenefitSocial) / 100)).toFixed(2),
        };


        setbenefitsTotals(newbenefitTotals);
        // Reset the selected activity form
        setSelectedActivity({
            ActivityID: '',
            Multiplier: 1,
            ActivityName: '',
            Frequency: '',
            SN_HoursDay: '',
            SN_HoursNight: '',
            ENA_HoursDay: '',
            ENA_HoursNight: '',
            CW_HoursDay: '',
            CW_HoursNight: '',
            BenefitBody: '',
            BenefitMind: '',
            BenefitSocial: '',
            DateFrom: '',
            DateTo: ''
        });
    };



    const navigate = useNavigate();

    const handleCreateQuote = async () => {
        try {
            const response = await fetch('https://marzdev.yourcrm.co.za/api/createQuote', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CarePlanID: carePlan.CarePlanID,
                    CustomerID: carePlan.CustomerID,
                    DateCreated: new Date().toISOString().split('T')[0],
                })
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Quote created successfully:', result);

                navigate(`/quotation/${carePlan.CustomerID}/${new Date().toISOString().split('T')[0]}/${result.quotationId}`);

            } else {
                console.error('Failed to create quote:', response.statusText);
            }
        } catch (error) {
            console.error('An error occurred while creating the quote:', error);
        }
    };


    // Helper function to calculate the cost of each line item
    const [hourlyRates, setHourlyRates] = useState({ SN: 0, ENA: 0, CW: 0 });
    const fetchHourlyRates = async (dateCreated) => {
        try {
            const response = await fetch(`https://marzdev.yourcrm.co.za/api/staff/rates?dateCreated=${dateCreated}`);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Check if the response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                throw new Error("Received non-JSON response");
            }

            const ratesArray = await response.json();

            // Convert the array to an object with SN, ENA, CW keys
            const mappedRates = ratesArray.reduce((acc, rate) => {
                const { StaffType, StandardHourlyPrice } = rate;
                acc[StaffType] = parseFloat(StandardHourlyPrice) || 0;
                return acc;
            }, { SN: 0, ENA: 0, CW: 0 });

            setHourlyRates(mappedRates);
        } catch (error) {
            console.error('Error fetching hourly rates:', error);
        }
    };



    // Function to calculate cost based on hourly rates
    const calculateCost = async (item) => {
        const hourlyRates = await fetchHourlyRates(dateCreated);

        if (!hourlyRates) {
            return 'Error calculating cost';
        }

        return (
            parseFloat(item.SN_HoursDay) * hourlyRates.SN +
            parseFloat(item.SN_HoursNight) * hourlyRates.SN +
            parseFloat(item.ENA_HoursDay) * hourlyRates.ENA +
            parseFloat(item.ENA_HoursNight) * hourlyRates.ENA +
            parseFloat(item.CW_HoursDay) * hourlyRates.CW +
            parseFloat(item.CW_HoursNight) * hourlyRates.CW
        ).toFixed(2);
    };


    // Helper function to calculate the total hours
    const calculateTotalHours = (lineItems) => {
        return lineItems.reduce((totals, item) => {
            return {
                SN_HoursDay: totals.SN_HoursDay + (parseFloat(item.SN_HoursDay) || 0),
                SN_HoursNight: totals.SN_HoursNight + (parseFloat(item.SN_HoursNight) || 0),
                ENA_HoursDay: totals.ENA_HoursDay + (parseFloat(item.ENA_HoursDay) || 0),
                ENA_HoursNight: totals.ENA_HoursNight + (parseFloat(item.ENA_HoursNight) || 0),
                CW_HoursDay: totals.CW_HoursDay + (parseFloat(item.CW_HoursDay) || 0),
                CW_HoursNight: totals.CW_HoursNight + (parseFloat(item.CW_HoursNight) || 0),
            };
        }, {
            SN_HoursDay: 0,
            SN_HoursNight: 0,
            ENA_HoursDay: 0,
            ENA_HoursNight: 0,
            CW_HoursDay: 0,
            CW_HoursNight: 0,
        });
    };

    // Helper function to calculate the total cost
    const calculateTotalCost = (lineItems) => {
        return lineItems.reduce((total, item) => {
            return total + parseFloat(calculateCost(item));
        }, 0).toFixed(2);
    };


    const handleSubmit = async () => {
        try {
            if (creatingCarePlan) {
                console.log("Creating New Care Plan...");
                const response = await fetch('https://marzdev.yourcrm.co.za/api/createCarePlan', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        CustomerID: id,
                        DateCreated: new Date().toISOString().split('T')[0],
                        lineItems
                    })
                });

                console.log("Response Status:", response.status);

                if (response.ok) {
                    const result = await response.json();
                    console.log("Response JSON:", result);
                    alert('Care Plan submitted successfully');
                    setTimeout(() => window.location.reload(), 500);
                } else {
                    const errorText = await response.text();
                    console.error("Failed Response:", errorText);
                    alert('Failed to submit Care Plan');
                }
            } else {
                console.log("Editing Care Plan...");

                const updatedLineItems = [...(carePlan.lineItems || []), ...lineItems];
                console.log("Updated Line Items Sent:", JSON.stringify(updatedLineItems, null, 2));

                const response = await fetch('https://marzdev.yourcrm.co.za/api/EditCarePlan', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        CustomerID: id,
                        CarePlanID: carePlan.CarePlanID,
                        DateCreated: new Date().toISOString().split('T')[0],
                        lineItems: updatedLineItems
                    })
                });
                if (response.ok) {
                    const result = await response.json();
                    console.log("Result:", result);
                    setEdit(false);
                    alert('Care Plan edited successfully');
                } else {
                    const errorText = await response.text();
                    console.error("Failed Response:", errorText);
                    alert('Failed to edit Care Plan');
                }
            }
        } catch (error) {
            console.error('An error occurred:', error);
            alert('An error occurred while submitting the Care Plan');
        }
    };

    const handleAddDefault = (activity) => {
        // Get the multiplier or default to 1
        const selectedMultiplier = parseFloat(activity.Multiplier) || 1;

        // Create a new item with updated hours based on the multiplier
        const newItem = {
            ...activity,
            SN_HoursDay: (parseFloat(activity.SN_HoursDay) * selectedMultiplier).toFixed(2),
            SN_HoursNight: (parseFloat(activity.SN_HoursNight) * selectedMultiplier).toFixed(2),
            ENA_HoursDay: (parseFloat(activity.ENA_HoursDay) * selectedMultiplier).toFixed(2),
            ENA_HoursNight: (parseFloat(activity.ENA_HoursNight) * selectedMultiplier).toFixed(2),
            CW_HoursDay: (parseFloat(activity.CW_HoursDay) * selectedMultiplier).toFixed(2),
            CW_HoursNight: (parseFloat(activity.CW_HoursNight) * selectedMultiplier).toFixed(2),
        };

        // Update the line items
        setLineItems(prevLineItems => [...prevLineItems, newItem]);
        setFilteredItems(prevFilteredItems => [...prevFilteredItems, newItem]);
        setTemp(prevLineItems => [...prevLineItems, newItem]);

        // Update the totals using the functional version of setTotals to ensure the latest state is used
        setTotals(prevTotals => ({
            SN_HoursDay: prevTotals.SN_HoursDay + parseFloat(newItem.SN_HoursDay),
            SN_HoursNight: prevTotals.SN_HoursNight + parseFloat(newItem.SN_HoursNight),
            ENA_HoursDay: prevTotals.ENA_HoursDay + parseFloat(newItem.ENA_HoursDay),
            ENA_HoursNight: prevTotals.ENA_HoursNight + parseFloat(newItem.ENA_HoursNight),
            CW_HoursDay: prevTotals.CW_HoursDay + parseFloat(newItem.CW_HoursDay),
            CW_HoursNight: prevTotals.CW_HoursNight + parseFloat(newItem.CW_HoursNight),
        }));

        // Update the benefit totals using the functional version of setbenefitsTotals
        // Update the benefit totals using the functional version of setbenefitsTotals
        setbenefitsTotals(prevBenefitTotals => ({
            BenefitBody:
                (parseFloat(prevBenefitTotals.BenefitBody || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(activity.BenefitBody) / 100)).toFixed(2),

            BenefitMind:
                (parseFloat(prevBenefitTotals.BenefitMind || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(activity.BenefitMind) / 100)).toFixed(2),

            BenefitSocial:
                (parseFloat(prevBenefitTotals.BenefitSocial || 0) +
                    (
                        Number(newItem.SN_HoursDay) +
                        Number(newItem.SN_HoursNight) +
                        Number(newItem.ENA_HoursDay) +
                        Number(newItem.ENA_HoursNight) +
                        Number(newItem.CW_HoursDay) +
                        Number(newItem.CW_HoursNight)
                    ) * (Number(activity.BenefitSocial) / 100)).toFixed(2),
        }));

    };

    // Define the default activity IDs
    const defaultActivityIDs = [65, 53, 70, 91, 47, 41, 63, 92, 89, 54];

    // Add default activities when creating a care plan
    useEffect(() => {
        if (creatingCarePlan) {
            const addDefaultActivities = async () => {
                const filteredActivities = activities.filter(activity =>
                    defaultActivityIDs.includes(activity.ActivityID)
                );
                filteredActivities.forEach(activity => handleAddDefault(activity));
            };

            addDefaultActivities();

        }

    }, [creatingCarePlan, activities]);

    const calculateBenefit = (item, benefitType) => {
        return (
            (Number(item.SN_HoursDay) +
                Number(item.SN_HoursNight) +
                Number(item.ENA_HoursDay) +
                Number(item.ENA_HoursNight) +
                Number(item.CW_HoursDay) +
                Number(item.CW_HoursNight)) *
            (item.Multiplier || 1) *
            (Number(item[benefitType]) / 100)
        );
    };

    if (creatingCarePlan) {
        return (
            <div>
                <div className="container mt-4">
                    <h1>Create New Care Plan</h1>
                    <p>No existing care plan found. You can create a new care plan by selecting activities and submitting.</p>
                    <div>
                        {/* Render the form to create a new care plan */}
                        <div className="d-flex justify-content-center mt-4" style={{ gap: '20px' }}>

                            <Table striped bordered hover className="mt-4">

                                <thead>
                                    <tr>
                                        <th colSpan="4" style={{ textAlign: 'center' }}>
                                            <strong>Summary of Hours</strong>
                                        </th>

                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>SN Hours</th>
                                        <th>ENA Hours</th>
                                        <th>CW Hours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Day</td>
                                        <td>{totals.SN_HoursDay}</td>
                                        <td>{totals.ENA_HoursDay}</td>
                                        <td>{totals.CW_HoursDay}</td>
                                    </tr>
                                    <tr>
                                        <td>Night</td>
                                        <td>{totals.SN_HoursNight}</td>
                                        <td>{totals.ENA_HoursNight}</td>
                                        <td>{totals.CW_HoursNight}</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>{totals.SN_HoursDay + totals.SN_HoursNight}</td>
                                        <td>{totals.ENA_HoursDay + totals.ENA_HoursNight}</td>
                                        <td>{totals.CW_HoursDay + totals.CW_HoursNight}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table striped bordered hover className="mt-4">
                                <thead>
                                    <tr>
                                        <th colSpan="2" style={{ textAlign: 'center' }}>
                                            <strong>Summary of Benefits</strong>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Benefit Type</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lineItems.map((item, index) => (
                                        <tr key={index}>
                                        </tr>
                                    ))}

                                    {/* Benefit totals */}
                                    <tr>
                                        <td>Body</td>
                                        <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitBody'), 0).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td>Mind</td>
                                        <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitMind'), 0).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td>Social</td>
                                        <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitSocial'), 0).toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="text-center">
                        <h3>Care Plan</h3>
                    </div>
                    <Form>
                        <Form.Group controlId="activitySelect mb-4">
                            <Form.Label>Select Activity</Form.Label>
                            <Form.Control
                                as="select"
                                name="ActivityID"
                                style={{ width: 'auto' }}
                                value={JSON.stringify(selectedActivity)} // Display the selected activity name
                                onChange={handleActivityChange}

                            >
                                <option value="">Select an activity</option>
                                {activities
                                    .filter(activity => !filteredItems.some(item => item.ActivityID === activity.ActivityID))
                                    .map(activity => (
                                        <option key={activity.ActivityID} value={JSON.stringify(activity)}>
                                            {activity.ActivityName}
                                        </option>
                                    ))}
                            </Form.Control>
                        </Form.Group>
                        <Button disabled={selectedActivity.ActivityID == ""} className='mt-2' onClick={handleAddLineItem}>Add Line Item</Button>
                    </Form>

                    <Form.Control
                        type="text"
                        placeholder="Search by Activity Name..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="search-bar mt-4"
                    />
                    <div className='table-controls'>
                        <Button
                            variant="link"
                            onClick={() => setCollapsed(!collapsed)}
                        >
                            {collapsed ? <FaAngleRight /> : <FaAngleLeft />}
                            {collapsed ? "Expand Columns" : "Collapse Columns"}
                        </Button>
                    </div>
                    <div className='table-wrapper'>
                        <Table striped bordered hover >
                            <thead>
                                <tr>
                                    <th ></th>
                                    <th ></th>
                                    <th ></th>
                                    <th ></th>
                                    <th colSpan={2} onClick={() => handleSort('SN_HoursDay', true)}>SN Hours{getSortIndicator('SN_HoursDay')}</th>
                                    <th colSpan={2} onClick={() => handleSort('ENA_HoursDay', true)}>ENA Hours{getSortIndicator('ENA_HoursDay')}</th>
                                    <th colSpan={2} onClick={() => handleSort('CW_HoursDay', true)}>CW Hours{getSortIndicator('CW_HoursDay')}</th>
                                    <th colSpan={2} style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('BenefitBody', true)}>Benefit Body {getSortIndicator('BenefitBody')}</th>
                                    <th colSpan={2} style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('BenefitBody', true)}>Benefit Mind {getSortIndicator('BenefitBody')}</th>
                                    <th colSpan={2} style={{ display: collapsed ? 'none' : 'table-cell' }} onClick={() => handleSort('BenefitBody', true)}>Benefit Social {getSortIndicator('BenefitBody')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell' }}></th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell' }}></th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th style={{ top: 39 }}>Actions</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('ActivityName')}>Activity {getSortIndicator('ActivityName')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('Multiplier', true)}>Multiplier {getSortIndicator('Multiplier')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('Frequency')}>Frequency {getSortIndicator('Frequency')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('SN_HoursDay', true)}>Day {getSortIndicator('SN_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('SN_HoursNight', true)}>Night{getSortIndicator('SN_HoursNight')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('ENA_HoursDay', true)}>Day{getSortIndicator('ENA_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('ENA_HoursNight', true)}>Night{getSortIndicator('ENA_HoursNight')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('CW_HoursDay', true)}>Day{getSortIndicator('CW_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('CW_HoursNight', true)}>Night{getSortIndicator('CW_HoursNight')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }} onClick={() => handleSort('BenefitBody', true)}>%{getSortIndicator('BenefitBody')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>Hours</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }} onClick={() => handleSort('BenefitMind', true)}>%{getSortIndicator('BenefitMind')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>Hours</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }} onClick={() => handleSort('BenefitSocial', true)}>%{getSortIndicator('BenefitSocial')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }}>Hours</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }} onClick={() => handleSort('CustomerCareTypeID')}>Care Type {getSortIndicator('CustomerCareTypeID')}</th>
                                    <th style={{ display: collapsed ? 'none' : 'table-cell', top: 39 }} onClick={() => handleSort('GeneralCategory')}>General Category {getSortIndicator('GeneralCategory')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Button variant="link" onClick={() => {
                                                if (window.confirm("Are you sure you want to remove this item?")) {
                                                    handleRemoveLineItem(index);
                                                }
                                            }}>
                                                <FaTrash style={{ color: '#dc3545', fontSize: '1.2rem' }} />
                                            </Button>
                                        </td>
                                        <td>{item.ActivityName}</td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={item.Multiplier !== null && item.Multiplier !== undefined ? item.Multiplier : '1'}
                                                onChange={(e) => handleMultiplierChange(index, e.target.value)}
                                                onBlur={(e) => handleMultiplierBlur(index, e.target.value)}
                                            />
                                        </td>
                                        <td>{item.Frequency}</td>
                                        <td>{item.SN_HoursDay}</td>
                                        <td>{(item.SN_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                        <td>{(item.SN_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                        <td>{(item.ENA_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                        <td>{(item.ENA_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                        <td>{(item.CW_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(item.BenefitBody || 0)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{((Number(item.SN_HoursDay) + Number(item.SN_HoursNight) + Number(item.ENA_HoursDay) + Number(item.ENA_HoursNight) + Number(item.CW_HoursDay) + Number(item.CW_HoursNight)) * (item.Multiplier || 1) * (Number(item.BenefitBody) / 100)).toFixed(2)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(item.BenefitMind || 0)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{((Number(item.SN_HoursDay) + Number(item.SN_HoursNight) + Number(item.ENA_HoursDay) + Number(item.ENA_HoursNight) + Number(item.CW_HoursDay) + Number(item.CW_HoursNight)) * (item.Multiplier || 1) * (Number(item.BenefitMind) / 100)).toFixed(2)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{(item.BenefitSocial || 0)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{((Number(item.SN_HoursDay) + Number(item.SN_HoursNight) + Number(item.ENA_HoursDay) + Number(item.ENA_HoursNight) + Number(item.CW_HoursDay) + Number(item.CW_HoursNight)) * (item.Multiplier || 1) * (Number(item.BenefitSocial) / 100)).toFixed(2)}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{item.CustomerCareTypeID}</td>
                                        <td style={{ display: collapsed ? 'none' : 'table-cell' }}>{item.GeneralCategory}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>


                    <Button className="mt-4" onClick={handleSubmit}>Create Care Plan and Submit</Button>
                </div>
            </div>
        );
    }

    if (noActivities) {
        return (
            <div>
                <div className="container mt-4">
                    <h1>No Activities Available</h1>
                    <p>There are no activities available to add to the care plan at the moment.</p>
                </div>
            </div>
        );
    }

    if (!carePlan) {
        return
        <div>
            <Navbar bg="primary" variant="dark">
                <Navbar.Brand>Care Plan</Navbar.Brand>
                <Nav className="ml-auto">
                    <Dropdown>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                            Menu
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="/">Home</Dropdown.Item>
                            <Dropdown.Item href="/care-recipients">Customers</Dropdown.Item>
                            <Dropdown.Item href="/settings">Settings</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Nav>
            </Navbar>
            Loading...</div>;
    }

    return (
        <div>
            <div className="container mt-4">
                <h1>Care Plan Details</h1>
                <p>Care Plan ID: {carePlan.CarePlanID}</p>

                <div className="d-flex justify-content-center mt-4" style={{ gap: '20px' }}>

                    <Table striped bordered hover className="mt-4">

                        <thead>
                            <tr>
                                <th colSpan="4" style={{ textAlign: 'center' }}>
                                    <strong>Summary of Hours</strong>
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>SN Hours</th>
                                <th>ENA Hours</th>
                                <th>CW Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Day</td>
                                <td>{totals.SN_HoursDay}</td>
                                <td>{totals.ENA_HoursDay}</td>
                                <td>{totals.CW_HoursDay}</td>
                            </tr>
                            <tr>
                                <td>Night</td>
                                <td>{totals.SN_HoursNight}</td>
                                <td>{totals.ENA_HoursNight}</td>
                                <td>{totals.CW_HoursNight}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>{totals.SN_HoursDay + totals.SN_HoursNight}</td>
                                <td>{totals.ENA_HoursDay + totals.ENA_HoursNight}</td>
                                <td>{totals.CW_HoursDay + totals.CW_HoursNight}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table striped bordered hover className="mt-4">
                        <thead>
                            <tr>
                                <th colSpan="2" style={{ textAlign: 'center' }}>
                                    <strong>Summary of Benefits</strong>
                                </th>
                            </tr>
                            <tr>
                                <th>Benefit Type</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lineItems.map((item, index) => (
                                <tr key={index}>
                                </tr>
                            ))}

                            {/* Benefit totals */}
                            <tr>
                                <td>Body</td>
                                <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitBody'), 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Mind</td>
                                <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitMind'), 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Social</td>
                                <td>{lineItems.reduce((acc, item) => acc + calculateBenefit(item, 'BenefitSocial'), 0).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <div className="text-center">
                    <h3>Care Plan</h3>
                </div>
                <Form>
                    <Form.Group controlId="activitySelect mb-4">
                        <Form.Label>Select Activity</Form.Label>
                        <Form.Control
                            as="select"
                            name="ActivityID"
                            value={JSON.stringify(selectedActivity)} // Display the selected activity name
                            onChange={handleActivityChange}
                            style={{ width: 'auto' }}
                        >
                            <option value="">Select an activity to add to the plan</option>
                            {activities
                                .filter(activity => !filteredItems.some(item => item.ActivityID === activity.ActivityID))
                                .map(activity => (
                                    <option key={activity.ActivityID} style={{ backgroundColor: 'blue' }} value={JSON.stringify(activity)}>
                                        {activity.ActivityName}
                                    </option>
                                ))}
                        </Form.Control>
                    </Form.Group>
                    {/* Other form fields go here */}
                    <Button disabled={selectedActivity.ActivityID == ""} className='mt-2' onClick={handleAddLineItem}>Add Line Item</Button>
                </Form>

                <div className='table-wrapper mt-4'>
                    <Table striped bordered hover className=" table-wrapper">
                        <thead>
                            <tr>
                                <th>Activity</th>
                                <th>Multiplier</th>
                                <th>Frequency</th>
                                <th colSpan={2}>SN Hours (Day)</th>
                                <th colSpan={2}>ENA Hours (Night)</th>
                                <th colSpan={2}>CW Hours (Night)</th>
                                <th colSpan={2}>Benefit Body</th>
                                <th colSpan={2}>Benefit Mind</th>
                                <th colSpan={2}>Benefit Social</th>
                                <th>Care Type</th>
                                <th>General Category</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th style={{top: 39}}></th>
                                <th style={{top: 39}}></th>
                                <th style={{top: 39}}></th>
                                <th style={{top: 39}}>Day</th>
                                <th style={{top: 39}}>Night</th>
                                <th style={{top: 39}}>Day</th>
                                <th style={{top: 39}}>Night</th>
                                <th style={{top: 39}}>Day</th>
                                <th style={{top: 39}}>Night</th>
                                <th style={{top: 39}}>%</th>
                                <th style={{top: 39}}>Hours</th>
                                <th style={{top: 39}}>%</th>
                                <th style={{top: 39}}>Hours</th>
                                <th style={{top: 39}}>%</th>
                                <th style={{top: 39}}>Hours</th>
                                <th style={{top: 39}}></th>
                                <th style={{top: 39}}></th>
                                <th style={{top: 39}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {lineItems.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.ActivityName}</td>
                                    <td>{
                                        !edit ?
                                            `${item.Multiplier !== null && item.Multiplier !== undefined ? item.Multiplier : '1'}`
                                            :
                                            <Form.Control
                                                type="text"
                                                value={item.Multiplier !== null && item.Multiplier !== undefined ? item.Multiplier : '1'}
                                                onChange={(e) => handleMultiplierChange(index, e.target.value)}
                                                onBlur={(e) => handleMultiplierBlur(index, e.target.value)} // Add the onBlur handler
                                            />
                                    }
                                    </td>

                                    <td>{item.Frequency}</td>
                                    <td>{(item.SN_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.SN_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.ENA_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.ENA_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.CW_HoursDay || 0) * (item.Multiplier || 1)}</td>
                                    <td>{(item.CW_HoursNight || 0) * (item.Multiplier || 1)}</td>
                                    <td>{item.BenefitBody}</td>
                                    <td>
                                        <span>
                                            {(
                                                (Number(item.SN_HoursDay) +
                                                    Number(item.SN_HoursNight) +
                                                    Number(item.ENA_HoursDay) +
                                                    Number(item.ENA_HoursNight) +
                                                    Number(item.CW_HoursDay) +
                                                    Number(item.CW_HoursNight)) * (item.Multiplier || 1) *
                                                (Number(item.BenefitBody) / 100) // Ensure BenefitBody is a number
                                            ).toFixed(2)} {/* Optionally format to 2 decimal places */}
                                        </span>
                                    </td>
                                    <td>{item.BenefitMind}</td>
                                    <td>
                                        <span>
                                            {(
                                                (Number(item.SN_HoursDay) +
                                                    Number(item.SN_HoursNight) +
                                                    Number(item.ENA_HoursDay) +
                                                    Number(item.ENA_HoursNight) +
                                                    Number(item.CW_HoursDay) +
                                                    Number(item.CW_HoursNight)) * (item.Multiplier || 1) *
                                                (Number(item.BenefitMind) / 100) // Ensure BenefitBody is a number
                                            ).toFixed(2)} {/* Optionally format to 2 decimal places */}
                                        </span>
                                    </td>
                                    <td>{item.BenefitSocial}</td>
                                    <td>
                                        <span>
                                            {(
                                                (Number(item.SN_HoursDay) +
                                                    Number(item.SN_HoursNight) +
                                                    Number(item.ENA_HoursDay) +
                                                    Number(item.ENA_HoursNight) +
                                                    Number(item.CW_HoursDay) +
                                                    Number(item.CW_HoursNight)) * (item.Multiplier || 1) *
                                                (Number(item.BenefitSocial) / 100) // Ensure BenefitBody is a number
                                            ).toFixed(2)} {/* Optionally format to 2 decimal places */}
                                        </span>
                                    </td>
                                    <td>{item.CustomerCareTypeID}</td>
                                    <td>{item.GeneralCategory}</td>
                                    <td>
                                        <Button onClick={() => handleRemoveLineItem(index)}>Remove</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <Button className="mt-4" onClick={() => setEdit(!edit)}>{!edit ? 'Edit Care Plan' : 'Cancel Edit'}</Button>
                    {edit ? <Button className="mt-4" onClick={() => handleSubmit()}>Save Care Plan</Button> : <Button className="mt-4" onClick={handleCreateQuote}>Generate Quotation</Button>}
                </div>
            </div>
        </div>
    );
}

export default CarePlanDetail;
